import React, { useState } from 'react';
import { X, Check, Loader2 } from 'lucide-react';
import { useT } from '../utils/translate';
import { useModalOpen } from '../utils/modalLock';
import { OUTCOME_COLOR, OUTCOME_TAGS, outcomeLabelKey } from '../utils/dealOutcome';

// Vazifa "bajarildi" (isDone) bosqichiga o'tkazilganda ochiladigan modal —
// natija izohini (va, agar lidga bog'liq bo'lsa, sdelka tarixiga yozishni)
// hamda ixtiyoriy keyingi ("follow-up") vazifani bitta oqimda so'raydi.
// Haqiqiy PUT/POST so'rovlarini chaqiruvchi TasksPage orkestrlaydi (onConfirm),
// bu yerda faqat forma ma'lumotlari yig'iladi — TaskModal/onSave patterni bilan bir xil.
export default function CompleteTaskModal({ task, users, onConfirm, onClose, saving = false, canCreateFollowUp = true }) {
  const t = useT();
  useModalOpen();

  const [outcomeNote, setOutcomeNote] = useState('');
  const [logToDeal,   setLogToDeal]   = useState(!!task.deal);
  const [outcomeTag,  setOutcomeTag]  = useState('');

  const [createFollowUp,   setCreateFollowUp]   = useState(canCreateFollowUp);
  const [followUpTitle,    setFollowUpTitle]    = useState(task.title || '');
  const [followUpDue,      setFollowUpDue]      = useState('');
  const [followUpAssignee, setFollowUpAssignee] = useState(task.assignedTo?._id || task.assignedTo || '');

  const handleConfirm = () => {
    onConfirm({
      outcomeNote: outcomeNote.trim(),
      logToDeal: logToDeal && !!task.deal && !!outcomeNote.trim(),
      outcomeTag,
      followUp: (createFollowUp && followUpTitle.trim())
        ? { title: followUpTitle.trim(), dueDate: followUpDue ? new Date(followUpDue).toISOString() : null, assignedTo: followUpAssignee || null }
        : null,
    });
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-modal w-full max-w-md max-h-[90dvh] flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-surface-100 shrink-0">
          <h2 className="font-semibold text-ink flex items-center gap-2">
            <Check className="w-4 h-4 text-emerald-500" /> {t('tasks.completeTitle')}
          </h2>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-surface-100 text-ink-tertiary">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto px-5 py-4 space-y-4">
          <p className="text-sm font-medium text-ink truncate">{task.title}</p>

          <div>
            <textarea
              className="input w-full resize-none text-sm" rows={3}
              placeholder={t('tasks.outcomeNotePlaceholder')}
              value={outcomeNote} onChange={e => setOutcomeNote(e.target.value)} />
          </div>

          {task.deal && (
            <div className="space-y-2">
              <label className="flex items-center gap-2 text-sm text-ink-secondary cursor-pointer">
                <input type="checkbox" checked={logToDeal} onChange={e => setLogToDeal(e.target.checked)}
                  className="w-4 h-4 rounded border-surface-300 text-primary-500 focus:ring-primary-400" />
                {t('tasks.logToDeal')}
              </label>
              {logToDeal && (
                <div className="flex flex-wrap gap-1.5 pl-6">
                  {OUTCOME_TAGS.map(tag => (
                    <button key={tag} type="button" onClick={() => setOutcomeTag(outcomeTag === tag ? '' : tag)}
                      className={`text-[11px] font-medium px-2 py-0.5 rounded-full border transition-colors ${outcomeTag === tag ? (OUTCOME_COLOR[tag] || 'bg-primary-500 text-white') + ' border-transparent' : 'bg-transparent border-surface-200 text-ink-tertiary hover:border-primary-300'}`}>
                      {t(outcomeLabelKey(tag))}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {canCreateFollowUp && (
          <div className="border-t border-surface-100 pt-4 space-y-3">
            <label className="flex items-center gap-2 text-sm font-medium text-ink cursor-pointer">
              <input type="checkbox" checked={createFollowUp} onChange={e => setCreateFollowUp(e.target.checked)}
                className="w-4 h-4 rounded border-surface-300 text-primary-500 focus:ring-primary-400" />
              {t('tasks.createFollowUp')}
            </label>
            {createFollowUp && (
              <div className="pl-6 space-y-2">
                <input type="text" className="input w-full text-sm" placeholder={t('tasks.followUpTitle')}
                  value={followUpTitle} onChange={e => setFollowUpTitle(e.target.value)} />
                <input type="datetime-local" className="input w-full text-sm" value={followUpDue}
                  onChange={e => setFollowUpDue(e.target.value)} />
                <select className="input w-full text-sm" value={followUpAssignee}
                  onChange={e => setFollowUpAssignee(e.target.value)}>
                  <option value="">{t('tasks.followUpAssignee')}</option>
                  {users.map(u => <option key={u._id} value={u._id}>{u.name}</option>)}
                </select>
              </div>
            )}
          </div>
          )}
        </div>

        <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-surface-100 shrink-0">
          <button onClick={onClose} className="btn-secondary btn-md">{t('tasks.cancel')}</button>
          <button onClick={handleConfirm} disabled={saving} className="btn-primary btn-md flex items-center gap-2">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />}
            {t('tasks.completeConfirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
